import { Record } from "immutable";

export class ProductRecord extends Record({
    id: null,
    name: null,
    description: null,
    is_active: true,
    created_by: null,
    modified_by: null,
    create_date: null,
    modified_date: null
}) {}
